<div class="footer-content flex items-center justify-between h-full px-8 bg-primary-gray-200 text-primary-gray-50">
  <span class="font-normal" data-testid="footer-license-expiry">
    @if (licenseExpiry) {
      License for Gopher for Chrome Premium expires on {{ licenseExpiry | date: 'MM/dd/yyyy' }}
    }
  </span>
  <div class="footer-right flex flex-row items-center gap-3 mr-[4rem]">
    <a
      class="footer-link text-primary-gray-50 font-normal"
      [href]="privacyUrl"
      target="_blank"
      data-testid="footer-legal-info-link"
      >Privacy Policy</a
    >
    <span class="font-normal">v{{ version }}@if (!isProduction) { | {{ revision }}}</span>
  </div>
  <div class="footer-bg"></div>
</div>